import React, { ReactNode, useEffect } from 'react'

const RowItemMeasurer: any = ({ children, measure }: { measure: any; children: ReactNode }) => {
  useEffect(() => {
    // FIXME: 發現商品卡高度有時會算錯才需要這段
    measure()
  }, [])
  return <React.Fragment>{children}</React.Fragment>
}

export default RowItemMeasurer
